import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid'
import {groupBy} from "lodash";
import {Link, useLocation} from "react-router-dom";
import {useMemo} from "react";

const bureauPlans = [
  {
    title: 'Pay as You Go',
    featured: false,
    description: 'For small payroll bureaus and small accountants ',
    priceMonthly: 1,
    country: ['uk-old'],
    mainFeatures: [
      { id: 1, value: 'No Commitment' },
      { id: 2, value: 'Employee App' },
      { id: 3, value: 'Compliant Payroll' },
      { id: 4, value: 'Cloud Infrastructure' },
      { id: 5, value: '24/7 Access' },
    ],
  },
  {
    title: 'Pay as You Go',
    featured: false,
    description: 'For small payroll bureaus and small accountants ',
    priceMonthly: 2,
    country: ['mt-old'],
    mainFeatures: [
      { id: 1, value: 'No Commitment' },
      { id: 2, value: 'Employee App' },
      { id: 3, value: 'Compliant Payroll' },
      { id: 4, value: 'Cloud Infrastructure' },
      { id: 5, value: '24/7 Access' },
    ],
  },
/*  {
    title: 'Bureau Unlimited',
    featured: true,
    description: 'For payroll bureaus who process higher volumes and do not want to worry about per employee costs for basic payroll',
    priceYearly: 750,
    country: ['mt'],
    mainFeatures: [
      { id: 1, value: 'Unlimited Basic Payroll' },
      { id: 2, value: 'Unlimited Team Members' },
      { id: 3, value: 'Employee App' },
      { id: 4, value: 'Compliant Payroll' },
      { id: 5, value: 'Cloud Infrastructure' },
      { id: 6, value: '24/7 Access' },
    ],
  },*/
  {
    title: 'Bureau Basic',
    // link: `https://calendly.com/buddy-cs/mt`,
    featured: false,
    description: 'For payroll bureaus who process higher volumes and do not want to worry about per employee costs for basic payroll',
    // priceYearly: 750,
    pricePerPayslip: 0.65,
    priceMonthly: 65,
    country: ['mt'],
    mainFeatures: [
      { id: 1, value: 'Unlimited Payslips' },
      { id: 2, value: 'Unlimited Team Members' },
      { id: 3, value: 'Employee App' },
      { id: 6, value: '24/7 Access' },
    ],
  },
  {
    title: 'Bureau Premium',
    // link: `https://calendly.com/buddy-cs/mt`,
    featured: true,
    pricePerPayslip: 0.65,
    priceMonthly: 325,
    description: 'For payroll bureaus who process higher volumes and do not want to worry about per employee costs for basic payroll',
    // priceYearly: 750,
    country: ['mt'],
    mainFeatures: [
      { id: 1, value: 'Everything in Standard' },
      { id: 2, value: 'Branded Client Portal' },
      { id: 3, value: 'Branded Reports' },
      { id: 3, value: 'Branded Emails' },
      { id: 4, value: 'Billing Module (coming soon)' },
    ],
  },
  {
    title: 'Bureau Enterprise',
    link: `https://calendly.com/buddy-cs/mt`,
    country: ['mt'],
    featured: false,
    description: 'For Payroll Bureaus processing over 5,000 payslips a month.',
    mainFeatures: [
      { id: 0, value: 'Everything in Premium' },
      { id: 1, value: 'Enterprise Payroll Migration' },
      { id: 4, value: 'Use your own domain' },
      { id: 3, value: 'Bespoke API Integrations' },
    ],
  },
  {
    title: 'Bureau Basic',
    link: `https://calendly.com/buddy-intro/[country]`,
    featured: false,
    description: 'For payroll bureaus who process higher volumes and do not want to worry about per employee costs for basic payroll',
    // priceYearly: 750,
    pricePerPayslip: 0.50,
    priceMonthly: 50,
    country: ['uk'],
    mainFeatures: [
      { id: 1, value: 'Unlimited Payslips' },
      { id: 2, value: 'Unlimited Team Members' },
      { id: 3, value: 'Employee App' },
      { id: 6, value: '24/7 Access' },
    ],
  },
  {
    title: 'Bureau Premium',
    link: `https://calendly.com/buddy-intro/[country]`,
    featured: true,
    description: 'For payroll bureaus who are very sensitive of their brand and operate with larger teams',
    // priceYearly: 750,
    pricePerPayslip: 0.50,
    priceMonthly: 250,
    country: ['uk'],
    mainFeatures: [
      { id: 1, value: 'Everything in Standard' },
      { id: 2, value: 'Branded Client Portal' },
      { id: 3, value: 'Branded Reports' },
      { id: 3, value: 'Branded Emails' },
      { id: 4, value: 'Billing Module (coming soon)' },
    ],
  },
  {
    title: 'Bureau Enterprise',
    link: `https://calendly.com/buddy-intro/[country]`,
    country: ['uk'],
    featured: false,
    description: 'For Payroll Bureaus processing over 50,000 payslips a month.',
    mainFeatures: [
      { id: 0, value: 'Everything in Premium' },
      { id: 1, value: 'Enterprise Payroll Migration' },
      { id: 4, value: 'Use your own domain' },
      { id: 3, value: 'Bespoke API Integrations' },
    ],
  },
]
const plans = [
  {
    title: 'Bureau Basic',
    featured: false,
    description: 'For small payroll bureaus, bookkeepers and accountants who do not want to have a branded portal.',
    priceMonthly: 1,
    priceYearly: 56,
    mainFeatures: [
      { id: 1, value: 'Employee Details' },
      { id: 2, value: 'Employee App' },
      { id: 3, value: 'Vacation Calendar' },
      { id: 4, value: 'Multi User' },
      { id: 5, value: 'Multi Business' },
      { id: 7, value: 'Bureau / Advisor connected' },
    ],
  },
  {
    title: 'Bureau Premium',
    featured: true,
    description: 'For payroll bureaus who want to leverage their brand, through branded client portal, reports and automated billing.',
    priceMonthly: 2,
    priceYearly: 140,
    mainFeatures: [
      { id: 1, value: 'All in Starter' },
      { id: 3, value: 'Vacation Management' },
      { id: 3, value: 'WFH Schedule' },
      { id: 4, value: 'Time & Attendance + Integrations' },
      { id: 5, value: 'Pensions' },
      { id: 6, value: 'Statutory Benefits' },
      { id: 7, value: 'Payroll' },
    ],
  },
  {
    title: 'Bureau Enterprise',
    featured: false,
    description: 'For payroll bureaus who want to use their own domain, and have bespoke workflow requirements.',
    priceMonthly: 3,
    priceYearly: 220,
    mainFeatures: [
      { id: 1, value: 'All in Business' },
      { id: 2, value: 'AccuPay™' },
      { id: 3, value: 'TimesheetPic™' },
      { id: 4, value: 'Sales Integrations' },
      { id: 5, value: 'Holiday Pay Calculation' },
      { id: 6, value: 'Advanced Reports' },
    ],
  },
]
const features = [
  // {
  //   title: 'Pay as You Go',
  //   group: 'Pricing',
  //   tiers: [
  //     { title: 'starter', value: `1` },
  //     { title: 'popular', featured: true, value: `2` },
  //     { title: 'intermediate', value: `3` },
  //   ],
  //   country: ['uk']
  // },
  // {
  //   title: 'Pay as You Go',
  //   group: 'Pricing',
  //   tiers: [
  //     { title: 'starter', value: `N/A` },
  //     { title: 'popular', featured: true, value: `2` },
  //     { title: 'intermediate', value: `3` },
  //   ],
  //   country: ['mt']
  // },
  // {
  //   title: 'Bureau Unlimited',
  //   group: 'Pricing',
  //   tiers: [
  //     { title: 'starter', value: `Included` },
  //     { title: 'popular', featured: true, value: `1` },
  //     { title: 'intermediate', value: `2` },
  //   ],
  // },
  {
    title: 'Compliant Payroll',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Live Chat & Email Support',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'National Minimum Wage Checks',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Auto Enrolment',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
    country: ['uk']
  },
  {
    title: 'Holiday Pay',
    hover: 'Automatically calculate holiday pay based on the latest legislation with a lookback of 52 qualifying weeks out of the last 104. Accuracy of calculation will depend on quality of data, plans supporting timesheet entry and calculations are bound to be more accurate on monthly pay.',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
    country: ['uk']
  },
  {
    title: 'Statutory Bonuses',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
    country: ['mt']
  },
  {
    title: 'Holiday Entitlements',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
    country: ['mt']
  },
  {
    title: 'Sick Benefit Deductions',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
    country: ['mt']
  },
  {
    title: 'AccuPay™',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Transparent Calculations',
    hover: 'No more need for tax tables. For each calculation Buddy enables you to hover over a tax value to see the exact calculations line by line.',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
    country: ['uk']
  },
  {
    title: 'Backpay',
    hover: 'Calculate payments due for backdated salary changes, or new starters that were added to the payroll 1 month late',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
    country: ['uk']
  },
  {
    title: 'Foreign Tax (Article 5)',
    hover: 'Support Article 5 tax deductions for Employees who are also taxed in another country that has a double taxation agreement with the UK.',
    group: 'Payroll Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
    country: ['uk']
  },


  {
    title: 'Leave Management',
    group: 'Client Collaboration',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Occupational Holiday/Sick Schemes',
    group: 'Client Collaboration',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Employee App',
    group: 'Client Collaboration',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Client Data Entry',
    group: 'Client Collaboration',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Client Payroll Review',
    group: 'Client Collaboration',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Use your own Email',
    group: 'Client Collaboration',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Branded Portal',
    group: 'Client Collaboration',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Branded Reports',
    group: 'Client Collaboration',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: 'Planned' },
      { title: 'intermediate', value: 'Planned' },
    ],
  },


  {
    title: 'Multi-User',
    group: 'Bureau Management',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Multi-Business',
    group: 'Bureau Management',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Custom Reports',
    group: 'Bureau Management',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Journal Reports',
    group: 'Bureau Management',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Audit Logs',
    hover: "Detailed audit logs that trace all changes made on an employee's record including who and when the changes where made.",
    group: 'Bureau Management',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Custom Workflows',
    group: 'Bureau Management',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: false },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Billing Module',
    group: 'Bureau Management',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: 'Planned' },
      { title: 'intermediate', value: 'Planned' },
    ],
  },


  {
    title: 'Tax Updates',
    group: "Compliance",
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Automatic NIC Letters',
    group: "Compliance",
    country: ["uk"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Pensions & Auto Enrolment',
    group: "Compliance",
    country: ["uk"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'P45 / P60',
    group: "Compliance",
    country: ["uk"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'HMRC RTI',
    group: "Compliance",
    country: ["uk"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'CIS 300',
    group: "Compliance",
    country: ["uk"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'EPS / FPS',
    group: "Compliance",
    country: ["uk"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Automated COLA Updates',
    group: "Compliance",
    country: ["mt"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'FS4',
    group: "Compliance",
    country: ["mt"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'FS3/FS5/FS7',
    group: "Compliance",
    country: ["mt"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'FSSXpress™',
    group: "Compliance",
    country: ["mt"],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Parental Leave',
    group: "Compliance",
    hover: 'Add Children date of births for automatic handling of available parental leave allocations',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },


  {
    title: 'Accounting',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Pensions',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
    country: ["uk"],
  },
  {
    title: 'Time & Attendance',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'One-Click Salary Payments',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true},
    ],
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Example() {
  let location = useLocation();

  const countryCode = location.pathname.split('/')[1]
  const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null

  const {groupedFeatures,currencySign,currency} = useMemo(() => {

    const countryFeatures = features.filter(feature => !feature.country || feature.country.includes(country))
    const groupedFeatures = groupBy(countryFeatures, 'group')

    const currencySign = country === 'uk' ? '£' : '€'
    const currency = country === 'uk' ? "GBP" : "EUR"

    // groupedFeatures['Pricing'].map(f => {
    //     f.tiers.map(t => {
    //       if (isNaN(t.value)) return
    //       t.value = currencySign + t.value
    //     })
    // })

    return {groupedFeatures,currencySign,currency}
  }, [country]);
  const hideUkPricing = country === 'uk'
  const trialStartLink = `/${country ?? 'mt'}/start`

  return (
    <div className="bg-gray-50">
      <div className="relative bg-advisor-900">
        {/* Overlapping background */}
        <div aria-hidden="true" className="absolute bottom-0 hidden h-6 w-full bg-gray-50 lg:block" />

        <div className="relative mx-auto max-w-2xl px-4 pt-16 text-center sm:px-6 sm:pt-32 lg:max-w-7xl lg:px-8">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
            <span className="block lg:inline">
              {hideUkPricing ? 'Enterprise-grade payroll. Expert-led from day one.' : 'Payroll Bureau Pricing'}
            </span>
            {/*<span className="block lg:inline">no commitment.</span>*/}
          </h1>
          <p className="mt-4 text-xl text-advisor-100 lg:max-w-3xl mx-auto">
            {hideUkPricing
              ? 'Buddy is a modern payroll platform built to handle real-world complexity. Our specialists help you choose the right setup, so you get the full power of the platform — without overpaying or overcomplicating things.'
              : 'Our Payroll Bureau plans are exclusively designed for licenced payroll professionals, designed to empower you to grow, regardless of your size.'}
          </p>
        </div>

        <h2 className="sr-only">Plans</h2>

        {hideUkPricing && (
          <div className="relative mx-auto mt-8 max-w-2xl px-4 pb-8 sm:mt-12 sm:px-6 lg:max-w-5xl lg:px-8">
            <div className="rounded-lg border border-gray-200 bg-white px-6 py-8 shadow-sm">
              <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
                <div className="flex-1">
                  <h3 className="text-base font-semibold text-advisor-900">Why our pricing starts with a conversation</h3>
                  <p className="mt-2 text-sm text-gray-600">
                    Payroll isn’t priced by employee count alone. Things like approval flows, multiple entities, pensions,
                    integrations, and bureau workflows all matter.
                  </p>
                  <ul className="mt-4 space-y-1 text-sm text-gray-600">
                    <li>One powerful platform across all plans</li>
                    <li>Flexible pricing based on how you actually use payroll</li>
                    <li>Expert guidance to make sure you don’t pay for things you don’t need</li>
                  </ul>
                  <p className="mt-4 text-sm text-gray-600">
                    You’ll receive a clear recommendation — and pricing — before you commit.
                  </p>
                </div>
                <div className="flex w-full flex-col gap-3 sm:w-auto">
                  <a
                    href={trialStartLink}
                    className="flex items-center justify-center rounded-md border border-transparent bg-advisor-900 px-5 py-3 text-base font-medium text-white hover:bg-advisor-700"
                  >
                    Get your recommended plan
                  </a>
                  <a
                    href={trialStartLink}
                    className="flex items-center justify-center rounded-md border border-advisor-900 bg-white px-5 py-3 text-base font-medium text-advisor-900 hover:bg-advisor-50"
                  >
                    Speak to a payroll specialist
                  </a>
                  <p className="text-xs text-gray-500">
                    Trusted by growing UK payroll teams • Clear pricing before you commit
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {hideUkPricing && (
          <div className="relative mx-auto max-w-2xl px-4 pb-2 sm:px-6 lg:max-w-5xl lg:px-8">
            <h3 className="text-lg font-semibold text-white">One platform. Configured to fit your payroll.</h3>
            <p className="mt-2 text-sm text-advisor-100">
              Every Buddy customer runs on the same robust payroll engine. What changes is the level of automation,
              control, and scale you need — and we help you get that right from the start.
            </p>
          </div>
        )}

        {/* Toggle */}
        {/*<div className="relative mt-12 flex justify-center sm:mt-16">
          <div className="flex rounded-lg bg-advisor-700 p-0.5">
            <button
              type="button"
              className="relative whitespace-nowrap rounded-md border-advisor-700 bg-white py-2 px-6 text-sm font-medium text-advisor-700 shadow-sm hover:bg-advisor-50 focus:z-10 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-advisor-700"
            >
              Monthly billing
            </button>
            <button
              type="button"
              className="relative ml-0.5 whitespace-nowrap rounded-md border border-transparent py-2 px-6 text-sm font-medium text-advisor-200 hover:bg-advisor-800 focus:z-10 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-advisor-700"
            >
              Yearly billing
            </button>
          </div>
        </div>*/}

        {/* Cards */}
        <div className="relative mx-auto mt-8 max-w-2xl px-4 pb-8 sm:mt-12 sm:px-6 lg:max-w-7xl lg:px-8 lg:pb-0">
            {/* Decorative background */}
            <div
              aria-hidden="true"
              className="absolute inset-0 top-4 bottom-6 left-8 right-8 hidden rounded-tl-lg rounded-tr-lg bg-advisor-700 lg:block"
            />

            <div className="relative space-y-6 lg:grid lg:grid-cols-3 lg:space-y-0">
              {bureauPlans
                  .filter(p => !p.country || p.country.includes(country))
                  .map((plan) => (
                <div
                  key={plan.title}
                  className={classNames(
                    plan.featured ? 'bg-white ring-2 ring-advisor-700 shadow-md' : 'bg-advisor-700 lg:bg-transparent',
                    'pt-6 px-6 pb-3 rounded-lg lg:px-8 lg:pt-12'
                  )}
                >
                  <div>
                    <h3
                      className={classNames(plan.featured ? 'text-advisor-900' : 'text-white', 'text-3xl font-bold')}
                    >
                      {plan.title}
                    </h3>
                    <div className="flex flex-col items-start sm:flex-row sm:items-center sm:justify-between lg:flex-col lg:items-start">
                      <div className="mt-3 flex items-center">
                      {hideUkPricing ? (
                        <p className={classNames(plan.featured ? 'text-advisor-900' : 'text-white', 'text-base font-semibold')}>
                          Expert-led plan recommendations
                        </p>
                      ) : (
                        <>
                          {(plan.priceMonthly ?? plan.priceYearly) && (
                            <>
                              <p
                                className={classNames(
                                  plan.featured ? 'text-advisor-900' : 'text-white',
                                  'text-4xl font-bold tracking-tight relative'
                                )}
                              >
                                <span className={classNames(plan.featured ? 'text-gray-700' : 'text-white', 'text-sm absolute -top-3 w-20 font-light')}>
                                  {plan.priceMonthly && !plan.pricePerPayslip ? <>starts at</> : ``}
                                </span>
                                {currencySign}{plan.pricePerPayslip ? plan.pricePerPayslip.toFixed(2) : plan.priceMonthly ?? plan.priceYearly}
                              </p>
                              <div className="ml-4">
                                <p className={classNames(plan.featured ? 'text-gray-700' : 'text-white', 'text-sm')}>
                                  {plan.priceMonthly && !plan.pricePerPayslip ? <>/ Active Employee<sup>1</sup> / mo</> : plan.pricePerPayslip ? <>/ Payslip</> : ` / year`}
                                </p>
                                {/*
                                  <p className={classNames(plan.featured ? 'text-gray-500' : 'text-advisor-200', 'text-sm')}>
                                    Billed yearly ({currencySign}{plan.priceYearly})
                                  </p>
                                */}
                              </div>
                            </>
                          )}
                        </>
                      )}
                      </div>

                    {!hideUkPricing && (
                      <>
                        {plan.pricePerPayslip && plan.priceMonthly && (
                          <div className="flex items-center">
                            <p className={classNames(plan.featured ? 'text-gray-700' : 'text-white', 'text-sm')}>
                              + {currencySign}{plan.priceMonthly} / month
                            </p>
                          </div>
                        )}
                        {
                          plan.link ?
                              <Link
                                // to={`/${country}/payroll-bureau`}
                                  to={plan.link.replace("[country]",country)}
                                  target="_blank"
                                className={classNames(
                                  plan.featured
                                    ? 'bg-advisor-900 text-white hover:bg-advisor-700'
                                    : 'bg-white text-advisor-900 hover:bg-advisor-50',
                                  'mt-6 w-full inline-block py-2 px-8 border border-transparent rounded-md shadow-sm text-center text-sm font-medium sm:mt-0 sm:w-auto lg:mt-6 lg:w-full'
                                )}
                              >
                                Talk to an Expert
                              </Link>
                              :
                            <Link
                              to={`/${country}/payroll-bureau/start`}
                              className={classNames(
                                plan.featured
                                  ? 'bg-advisor-900 text-white hover:bg-advisor-700'
                                  : 'bg-white text-advisor-900 hover:bg-advisor-50',
                                'mt-6 w-full inline-block py-2 px-8 border border-transparent rounded-md shadow-sm text-center text-sm font-medium sm:mt-0 sm:w-auto lg:mt-6 lg:w-full'
                              )}
                            >
                              Start with {plan.title}
                            </Link>
                        }
                      </>
                    )}
                    {hideUkPricing && (
                      <a
                        href={trialStartLink}
                        className={classNames(
                          plan.featured
                            ? 'bg-advisor-900 text-white hover:bg-advisor-700'
                            : 'bg-white text-advisor-900 hover:bg-advisor-50',
                          'mt-6 w-full inline-block py-2 px-8 border border-transparent rounded-md shadow-sm text-center text-sm font-medium sm:mt-0 sm:w-auto lg:mt-6 lg:w-full'
                        )}
                      >
                        Get your recommended plan
                      </a>
                    )}
                    </div>
                  </div>
                  <h4 className="sr-only">Features</h4>
                  <ul
                    role="list"
                    className={classNames(
                      plan.featured
                        ? 'border-gray-200 divide-gray-200'
                        : 'border-advisor-500 divide-advisor-500 divide-opacity-75',
                      'mt-7 border-t divide-y lg:border-t-0'
                    )}
                  >
                    {plan.mainFeatures.map((mainFeature) => (
                      <li key={mainFeature.id} className="flex items-center py-3">
                        <CheckIcon
                          className={classNames(
                            plan.featured ? 'text-advisor-500' : 'text-advisor-200',
                            'w-5 h-5 flex-shrink-0'
                          )}
                          aria-hidden="true"
                        />
                        <span
                          className={classNames(
                            plan.featured ? 'text-gray-900' : 'text-white',
                            'ml-3 text-sm font-medium'
                          )}
                        >
                          {mainFeature.value}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
      </div>

      {/* Feature comparison (up to lg) */}
      <section aria-labelledby="mobile-comparison-heading" className="lg:hidden">
          <h2 id="mobile-comparison-heading" className="sr-only">
            Feature comparison
          </h2>

          <div className="mx-auto max-w-2xl space-y-16 py-16 px-4 sm:px-6">
            {plans.map((plan, mobilePlanIndex) => (
              <div key="plan.title" className="border-t border-gray-200">
                <div
                  className={classNames(
                    plan.featured ? 'border-advisor-900' : 'border-transparent',
                    '-mt-px pt-6 border-t-2 sticky top-0 bg-gray-50 z-50'
                  )}
                >
                  <h3 className={classNames(plan.featured ? 'text-advisor-900' : 'text-gray-900', 'text-sm font-bold')}>
                    {plan.title}
                  </h3>
                  <p className="mt-2 text-sm text-gray-500">{plan.description}</p>
                </div>

                {
                  Object.keys(groupedFeatures)?.map(group => (
                      <>
                        <h4 className="mt-10 text-sm font-bold text-gray-900">{group}</h4>

                        <div className="relative mt-6">
                          {/* Fake card background */}
                          <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden sm:block">
                            <div
                              className={classNames(
                                plan.featured ? 'shadow-md' : 'shadow',
                                'absolute right-0 w-1/2 h-full bg-white rounded-lg'
                              )}
                            />
                          </div>

                          <div
                            className={classNames(
                              plan.featured ? 'ring-2 ring-advisor-900 shadow-md' : 'ring-1 ring-black ring-opacity-5 shadow',
                              'relative py-3 px-4 bg-white rounded-lg sm:p-0 sm:bg-transparent sm:rounded-none sm:ring-0 sm:shadow-none'
                            )}
                          >
                            <dl className="divide-y divide-gray-200">
                              {groupedFeatures[group].map((feature) => (
                                <div
                                  key={feature.title}
                                  className="flex items-center justify-between py-3 sm:grid sm:grid-cols-2"
                                >
                                  <dt className="pr-4 text-sm font-medium text-gray-900" title={feature.hover}>
                                    {/*<ReactTooltip effect="solid" multiline={true} />*/}
                                    {feature.title}
                                  </dt>
                                  <dd className="flex items-center justify-end sm:justify-center sm:px-4">
                                    {typeof feature.tiers[mobilePlanIndex].value === 'string' ? (
                                      <span
                                        className={classNames(
                                          feature.tiers[mobilePlanIndex].featured ? 'text-advisor-900' : 'text-gray-900',
                                          'text-sm font-medium'
                                        )}
                                      >
                                        {feature.tiers[mobilePlanIndex].value}
                                      </span>
                                    ) : (
                                      <>
                                        {feature.tiers[mobilePlanIndex].value === true ? (
                                          <CheckIcon className="mx-auto h-5 w-5 text-advisor-900" aria-hidden="true" />
                                        ) : (
                                          <XMarkIcon className="mx-auto h-5 w-5 text-gray-400" aria-hidden="true" />
                                        )}

                                        <span className="sr-only">
                                          {feature.tiers[mobilePlanIndex].value === true ? 'Yes' : 'No'}
                                        </span>
                                      </>
                                    )}
                                  </dd>
                                </div>
                              ))}
                            </dl>
                          </div>

                          {/* Fake card border */}
                          <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden sm:block">
                            <div
                              className={classNames(
                                plan.featured ? 'ring-2 ring-advisor-900' : 'ring-1 ring-black ring-opacity-5',
                                'absolute right-0 w-1/2 h-full rounded-lg'
                              )}
                            />
                          </div>
                        </div>
                      </>
                  ))
                }

              </div>
            ))}
          </div>
        </section>

      {!hideUkPricing && (
        <div className="mx-auto max-w-md lg:max-w-5xl -mt-2">
          <span className="text-xs ml-3">* All prices are excluding VAT</span>
        </div>
      )}

       <div className="relative mx-auto mt-4 max-w-7xl px-4 sm:px-6 lg:mt-5 lg:px-8 pb-8">
        <div className="mx-auto max-w-md lg:max-w-5xl">
          <div className="rounded-lg bg-employer-900 px-6 py-8 sm:p-10 lg:flex lg:items-center">
            <div className="flex-1">
              <div>
                <h3 className="inline-flex rounded-full bg-white px-4 py-1 text-base font-semibold text-employer-800">
                  Not a Payroll Bureau?
                </h3>
              </div>
              <div className="mt-4 text-lg text-employer-100">
                Are you an employer with in-house payroll expertise?
                Our employer packages are made to help you keep all the key HR and payroll information.
              </div>
            </div>
            <div className="mt-6 rounded-md shadow lg:mt-0 lg:ml-10 lg:flex-shrink-0">
              <Link
                to={`/${countryCode}/employer/pricing`}
                className="flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-gray-900 hover:bg-gray-50"
              >
                Discover our Employer Pricing
              </Link>
            </div>
          </div>
        </div>
      </div>


      {/* Feature comparison (lg+) */}
      <section aria-labelledby="comparison-heading" className="hidden lg:block">

          <div className="mx-auto max-w-7xl py-24 px-8">
            <h2 className="mt-auto text-sm font-bold text-gray-900">Scalable Pricing</h2>
            <p className={'text-gray-600 text-sm mb-3 mt-1'}>
              Our pricing is designed to aid the growth of your payroll bureau; hop on a call with our team to help you identify the best plan for you.
            </p>
            <div className="flex w-full items-stretch border-t border-gray-200 sticky bg-gray-50 mb-1 z-50 top-0">
              <div className="-mt-px flex w-1/4 items-end py-6 pr-4">
                <h3 className="mt-auto text-sm font-bold text-gray-900">Compare Plans</h3>
              </div>
              {plans.map((plan, planIdx) => (
                <div
                  key={plan.title}
                  aria-hidden="true"
                  className={classNames(planIdx === plans.length - 1 ? '' : 'pr-4', '-mt-px pl-4 w-1/4')}
                >
                  <div
                    className={classNames(plan.featured ? 'border-advisor-900' : 'border-transparent', 'py-6 border-t-2')}
                  >
                    <p className={classNames(plan.featured ? 'text-advisor-900' : 'text-gray-900', 'text-sm font-bold')}>
                      {plan.title}
                    </p>
                    <p className="mt-2 text-sm text-gray-500">{plan.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {
              Object.keys(groupedFeatures).map((group) => (
                  <>
                    <h3 className="mt-10 text-sm font-bold text-gray-900">{group}</h3>
                     <div className="relative">
                        {/* Fake card backgrounds */}
                        <div className="pointer-events-none absolute inset-0 flex items-stretch" aria-hidden="true">
                          <div className="w-1/4 pr-4" />
                          <div className="w-1/4 px-4">
                            <div className="h-full w-full rounded-lg bg-white shadow" />
                          </div>
                          <div className="w-1/4 px-4">
                            <div className="h-full w-full rounded-lg bg-white shadow-md" />
                          </div>
                          <div className="w-1/4 pl-4">
                            <div className="h-full w-full rounded-lg bg-white shadow" />
                          </div>
                        </div>

                        <table className="relative w-full">
                          <caption className="sr-only">Business feature comparison</caption>
                          <thead>
                            <tr className="text-left">
                              <th scope="col">
                                <span className="sr-only">Feature</span>
                              </th>
                              {plans.map((plan) => (
                                <th key={plan.title} scope="col">
                                  <span className="sr-only">{plan.title} plan</span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-100">
                            {groupedFeatures[group].map((feature) => (
                              <tr key={feature.title}>
                                <th scope="row" className="w-1/4 py-3 pr-4 text-left text-sm font-medium text-gray-900">
                                  {feature.title}
                                </th>
                                {feature.tiers.map((tier, tierIdx) => (
                                  <td
                                    key={tier.title}
                                    className={classNames(
                                      tierIdx === feature.tiers.length - 1 ? 'pl-4' : 'px-4',
                                      'relative w-1/4 py-0 text-center'
                                    )}
                                  >
                                    <span className="relative h-full w-full py-3">
                                      {typeof tier.value === 'string' ? (
                                        <span
                                          className={classNames(
                                            tier.featured ? 'text-advisor-900' : 'text-gray-900',
                                            'text-sm font-medium'
                                          )}
                                        >
                                          {tier.value}
                                        </span>
                                      ) : (
                                        <>
                                          {tier.value === true ? (
                                            <CheckIcon className="mx-auto h-5 w-5 text-advisor-900" aria-hidden="true" />
                                          ) : (
                                            <XMarkIcon className="mx-auto h-5 w-5 text-gray-400" aria-hidden="true" />
                                          )}

                                          <span className="sr-only">{tier.value === true ? 'Yes' : 'No'}</span>
                                        </>
                                      )}
                                    </span>
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Fake card borders */}
                        <div className="pointer-events-none absolute inset-0 flex items-stretch" aria-hidden="true">
                          <div className="w-1/4 pr-4" />
                          <div className="w-1/4 px-4">
                            <div className="h-full w-full rounded-lg ring-1 ring-black ring-opacity-5" />
                          </div>
                          <div className="w-1/4 px-4">
                            <div className="h-full w-full rounded-lg ring-2 ring-advisor-900 ring-opacity-100" />
                          </div>
                          <div className="w-1/4 pl-4">
                            <div className="h-full w-full rounded-lg ring-1 ring-black ring-opacity-5" />
                          </div>
                        </div>
                     </div>
                  </>
              ))
            }
          </div>
        </section>

    </div>
  )
}
